import { render, staticRenderFns } from "./ShortCard.vue?vue&type=template&id=8c4ee66a&scoped=true&"
import script from "./ShortCard.vue?vue&type=script&lang=js&"
export * from "./ShortCard.vue?vue&type=script&lang=js&"
import style0 from "./ShortCard.vue?vue&type=style&index=0&id=8c4ee66a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4ee66a",
  null
  
)

export default component.exports